import authRules from '../authRules';

const changeDayType = (user) => {
  const { changeDayType } = user.securityLevels;
  if (changeDayType >= authRules.changeDayType.changeDayType) {
      return true;
  } else {
      return false;
    }
  }


export default changeDayType;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/changeDayType.js